import React, { FC } from 'react';
import { Button, Input } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { TPollAnswer } from 'features/poll/questionDrawer/QuestionDrawer';
import style from './index.module.scss';

type TPossibleAnswersProps = {
  answers: TPollAnswer[];
  onAddAnswer: () => void;
  onDeleteAnswer: (id: number) => void;
  onAnswerChange: (data: TPollAnswer[]) => void;
};

const PossibleAnwers: FC<TPossibleAnswersProps> = ({ answers, onAddAnswer, onDeleteAnswer, onAnswerChange }) => {
  const onChange = (value: string, index: number) => {
    const newAnswers = answers.map((elem, ind) => {
      if (index === ind) {
        elem.value = value;
      }
      return elem;
    });
    onAnswerChange(newAnswers);
  };

  return (
    <div>
      <h3>Варианты ответов</h3>
      <div className={style.answers}>
        {answers.map((elem, index) => (
          <div className={style.answer}>
            <Input
              placeholder="Введите вариант ответа"
              value={elem.value}
              onChange={(e: React.ChangeEvent) => onChange((e.target as HTMLInputElement).value, index)}
            />
            <CloseOutlined className={style['cross-icon']} onClick={() => onDeleteAnswer(index)} />
          </div>
        ))}
      </div>
      <Button className={style.button} onClick={onAddAnswer}>
        + Добавить
      </Button>
    </div>
  );
};

export default PossibleAnwers;
